<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{title}}</h4>
</div>
<div class="modal-body">
    <div class="row text-center">
        <p style="text-align: center;" class="col-md-12" *ngIf="seedPhrase">Palabras para recuperar Firma Electrónica:
        </p>
        <a>
            {{seedPhrase}}
        </a>
        <p style="text-align: center;" class="col-md-12" *ngIf="seedPhrase">(Copie y pegue estas palabras, les serán
            solicitadas si algún
            día llegara a olvidar su contraseña)</p>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="form-group col-md-12">
                <label class="form-control-label">Firma</label><span style="color:red"> * </span>
                <input type="password" class="form-control" appPassword>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="repeatSign">
        <div class="col-md-12">
            <div class="form-group col-md-12">
                <label class="form-control-label">Repetir Firma</label><span style="color:red"> * </span>
                <input type="password" class="form-control" appPassword>
            </div>
        </div>
    </div>

</div>
<div class="modal-footer">
    <button type="button" *ngFor="let btn of buttons" [class]="btn.cssClass ? btn.cssClass : 'btn btn-outline-dark'"
        (click)="btnClicked(btn)" [disabled]="btn.disabled == true">{{btn.text}}</button>
</div>